@if (userService.userData$ | async; as userData) {
  @if (menuMode) {
    <div style="display: flex" id="User_identifier_target">
      <ng-component
        *ngTemplateOutlet="userIdentifier; context: { $implicit: userData }"
      ></ng-component>
    </div>
    <sh-popover
      target="User_identifier_target"
      position="bottom"
      class="popover"
    >
      <div class="pt-10">
        <sh-text size="title-1" color="primary">{{
          userData.displayName
        }}</sh-text>
      </div>
      <div>
        <sh-text size="body-1" color="primary">{{ userData.mail }}</sh-text>
      </div>
      <sh-divider class="pt-10"></sh-divider>
      <div>
        <sh-menu-item
          icon="logoff"
          label="{{ 'label.logout' | translate }}"
          (click)="userService.logout()"
        >
        </sh-menu-item>
      </div>
    </sh-popover>
  }
  @if (!menuMode) {
    <ng-component
      *ngTemplateOutlet="userIdentifier; context: { $implicit: userData }"
    ></ng-component>
  }
}

<ng-template #userIdentifier let-userData>
  <sh-user-identifier
    [initials]="userService.userInitials$ | async"
    [name]="(layout.desktopLarge$ | async) ? userData.displayName : ''"
    [image]="userService.userProfilePicture$ | async"
    slot="user"
    info=""
  >
  </sh-user-identifier>
</ng-template>
